import axios from "../../../config/axiosConfig";

let _cache = null;
let _cacheTs = 0;

/**
 * GET /api/plataformas
 * @returns Promise<AxiosResponse<{id:number, nombre:string, url_plataforma?:string, descripcion?:string|null, estado:string}[]>>
 */
export const getPlataformas = () => axios.get("/api/plataformas");

/**
 * Devuelve plataformas activas ordenadas por nombre. Con caché en memoria.
 * @param {Object} opts
 * @param {boolean} [opts.useCache=true]
 * @param {number}  [opts.ttlMs=300000] - 5 minutos
 * @returns {Promise<Array>} Array de plataformas activas
 */
export const getPlataformasActivas = async ({ useCache = true, ttlMs = 5 * 60 * 1000 } = {}) => {
  const now = Date.now();
  if (useCache && _cache && now - _cacheTs < ttlMs) return _cache;

  const { data } = await getPlataformas();
  const activos = (Array.isArray(data) ? data : [])
    .filter((p) => String(p?.estado || "").toLowerCase() === "activo")
    .sort((a, b) => String(a?.nombre || "").localeCompare(String(b?.nombre || "")));

  if (useCache) {
    _cache = activos;
    _cacheTs = now;
  }
  return activos;
};

/**
 * Busca por nombre exacto (case-insensitive) dentro de las activas.
 * @param {string} name
 * @param {Object} opts - mismos opts que getPlataformasActivas
 * @returns {Promise<Object|null>}
 */
export const findPlataformaByName = async (name, opts) => {
  if (!name) return null;
  const list = await getPlataformasActivas(opts);
  const q = String(name).toLowerCase();
  return list.find((p) => String(p?.nombre || "").toLowerCase() === q) || null;
};

/**
 * Mapea plataformas a opciones de Select.
 * @param {Array} list
 * @returns {{value:string,label:string}[]}
 */
export const plataformasToOptions = (list = []) =>
  list.map((p) => ({ value: String(p.id), label: p.nombre }));
